import {type RouteRecordRaw} from 'vue-router';

const ChangeOldContract       = () => import('../../views/customer/ChangeOldContract.vue');
const ChangeOldContractVerify = () => import('../../views/customer/ChangeOldContractVerify.vue');

const meta: MetaData = {
    module: 'customer',
    layout: 'minimal',
    allowLoggedOut: true,
};

let invoiceChange: RouteRecordRaw[] = [
    {
        name: 'change-contract',
        path: '/umstellung',
        meta,
        component: ChangeOldContract,
    },
    {
        name: 'change-contract-verify',
        path: '/umstellung/verify/:code',
        meta,
        component: ChangeOldContractVerify,
    },
];

export default invoiceChange;
